<template>
  <div
    class="bg-ontick-carbon-500 fixed inset-0 flex items-center justify-center"
  >
    <i v-html="$icons.logo_public" class="animate-pulse"> </i>
    <span class="sr-only">Carregando</span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
